import { useState, useEffect, useCallback } from 'react';
import { useLabelsQuery } from '../../../hooks/useLabelsQuery';

const DEBOUNCE_DELAY = 400;

export const useLabelsSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const {
    data: labels = [],
    isLoading: loading,
    error: queryError,
  } = useLabelsQuery(debouncedQuery);

  const updateSearchQuery = useCallback((query: string) => {
    setSearchQuery(query);
  }, []);

  return {
    labels,
    loading,
    error: queryError ? 'Failed to search tags' : null,
    searchQuery,
    updateSearchQuery,
  };
};
